import * as yup from 'yup';
import { isSupportedCtLocale, isSupportedStoreLocale } from '@shared/utils';

/**
 * Validation schema for createCart mutation
 * Validates that the locale is not empty and is a valid CT locale
 */
export const createCartSchema = () => {
  return yup.object({
    locale: yup
      .string()
      .required('Locale is required')
      .test('is-valid-locale', 'Locale is invalid', (value) => {
        if (!value) return false;
        return isSupportedStoreLocale(value) || isSupportedCtLocale(value);
      }),
    storeKey: yup.string().required('Store key is required'),
    currency: yup.string().required('Currency is required'),
    anonymousId: yup.string(),
  });
};
